document.addEventListener("DOMContentLoaded", function () {
  class FooterSwiper extends HTMLElement {
    constructor() {
      super();
      this.slider = this.querySelector('.swiper');
      if (!this.slider) return;
      this.initSwiper();
    }

    initSwiper() {
      new Swiper(this.slider, {
        slidesPerView: 1,
        spaceBetween: 0,
        pagination: {
          el: this.slider.querySelector('.swiper-pagination'),
          clickable: true,
        },
        breakpoints: {
          750: {
            slidesPerView: 3,
            spaceBetween: 0
          },
          1366: {
            slidesPerView: 4,
            spaceBetween: 0
          }
        }
      });
    }
  }

  customElements.define('footer-swiper', FooterSwiper);
});
